/* global axios */
import ApiClient from './ApiClient';
import { requestConfig, resourcePath, withQuery } from './lais/httpHelpers';

class BlockedContactsAPI extends ApiClient {
  constructor() {
    super('blocked_contacts', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  create(payload = {}) {
    return axios.post(this.url, payload, requestConfig());
  }

  destroy(id, payload = {}) {
    return axios.delete(resourcePath(this.url, id), {
      ...requestConfig(),
      data: payload,
    });
  }
}

export default new BlockedContactsAPI();
